import { render, staticRenderFns } from "./seckillSendTips.vue?vue&type=template&id=1ae47917&scoped=true&"
import script from "./seckillSendTips.vue?vue&type=script&lang=js&"
export * from "./seckillSendTips.vue?vue&type=script&lang=js&"
import style0 from "./seckillSendTips.vue?vue&type=style&index=0&id=1ae47917&lang=stylus&scoped=true&"
import style1 from "./seckillSendTips.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae47917",
  null
  
)

export default component.exports